export default "__VITE_ASSET__76832720__"